var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDagger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344 128H200V8C200 3.578 196.406 0 192 0S184 3.578 184 8V128H40C17.938 128 0 145.938 0 168V192C0 196.422 3.594 200 8 200S16 196.422 16 192V168C16 154.766 26.781 144 40 144H128V424C128 425.641 128.5 427.25 129.438 428.594L185.438 508.594C186.938 510.719 189.375 512 192 512S197.062 510.719 198.562 508.594L254.562 428.594C255.5 427.25 256 425.641 256 424V144H344C357.219 144 368 154.766 368 168V192C368 196.422 371.594 200 376 200S384 196.422 384 192V168C384 145.938 366.062 128 344 128ZM240 421.484L192 490.047L144 421.484V144H240V421.484Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDagger);
export default __webpack_public_path__ + "static/media/dagger.c021a1ca0534be183a45fc08b8095050.svg";
export { ForwardRef as ReactComponent };